import React from 'react';

const DoorOverlay = ({ title, message, isOpen }) => {
  return (
    <div className={`door-overlay ${isOpen ? 'door-opening' : ''}`}>
      <div className="door-panel">
        <div className="door-handle" />
        <div className="door-content">
          <span className="door-title">{title}</span>
          <p className="door-message">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default DoorOverlay;
